import './css/styles.scss';

import Swiper from 'swiper';
import {Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/thumbs';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Fancybox } from '@fancyapps/ui';


const produktSlider = function() {
        // Initialize thumbnail slider
        var thumbnailSlider = new Swiper(".thumbnail-slider", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true, // Ensures thumbnails are clickable
        });
    
        // Initialize main slider and link it to thumbnail slider
        var mainSlider = new Swiper(".main-slider", {
            loop: true,
            spaceBetween: 10,
            autoHeight: true,
            thumbs: {
                swiper: thumbnailSlider,
            },
        });
    
        // Ensure manual thumbnail click updates main slider
        document.querySelectorAll('.thumbnail-slider .swiper-slide').forEach((thumb, index) => {
            thumb.addEventListener('click', function () {
                mainSlider.slideToLoop(index); // Go to corresponding slide
            });
        });

    // Initialize Fancybox for all gallery items
    Fancybox.bind("[data-fancybox='gallery']", {
        Toolbar: true,
        smallBtn: true,
    });
};

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	produktSlider();
});


